$(document).ready(function () {
  // Init only visible slider
  $('.tab-panel.active .slider').slick({
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4.5,
    slidesToScroll: 4,
    autoplay: false,
    autoplaySpeed: 3000,
    arrows: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3.5,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
        }
      }
    ]
  });

  $('.tab-btn').on('click', function () {
    var tabId = $(this).data('tab');

    // Tab button active class
    $('.tab-btn').removeClass('active');
    $(this).addClass('active');

    // Show/hide tab panels
    $('.tab-panel').removeClass('active').hide();
    $('#' + tabId).addClass('active').show();

    // Init slick if not initialized
    const $slider = $('#' + tabId).find('.slider');
    if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 4.5,
        slidesToScroll: 4,
        autoplay: false,
        autoplaySpeed: 3000,
        arrows: false,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3.5,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 2.5,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1,
            }
          }
        ]
      });
    }
  });
});

$('.logo_bar_image').slick({
  arrows: false,
  autoplay: true,
  autoplaySpeed: 0,  
  speed: 4000,   
  cssEase: 'linear',
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 749,
      settings: {
        arrows:false,
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});